<script lang="ts">
    import { DEFAULT_BOX } from '$lib/components/constants';

    import { getBorderRadius } from '$lib/global/helper/border-radius';
    import { cn } from '$lib/utils/cn';
    import { getResponseBgColor } from '$lib/utils/getResponseBgColor';

    import { fade } from 'svelte/transition';
    import CountUp from 'svelte-countup';

    import AnswerIcon from '../_wrappers/AnswerIcon.svelte';
    import Text from '../Text/Text.View.svelte';

    export let id = '';
    export let link = '';
    export let wysiwygHtml: string | undefined = undefined;
    export let emoji = ':smiley:';
    export let icon = '';
    export let showIcon = true;
    export let srcType = '';
    export let iconName = '';
    export let platform = '';
    export let iconColor = '#000000';
    export let svg = '';
    export let isAnimated = false;
    export let jsonUrl: string | null = null;
    export let color = 'black';
    export let bgColor: string | undefined = undefined;
    export let borderColorStyle: string | undefined = undefined;
    export let borderRadiusClass: string | undefined = undefined;
    export let resultId = '';
    export let onClick: (resultId: string, id: string, link: string) => void;
    export let onMouseEnter: (resultId: string, id: string, link: string) => void;
    export let isResultVisible = false;
    export let responsePercentage: number | undefined = 0;

    const handleClick = (evt: Event) => {
        evt.stopPropagation();

        // Prevent clicks after results are shown
        if (isResultVisible) {
            return;
        }

        onClick(resultId, id, link);
    };

    const handleKeyPress = (event: KeyboardEvent) => {
        event.preventDefault();

        if (event.key === 'Enter' || event.key === ' ') {
            handleClick(event);
        }
    };

    const handleMouseEnter = () => {
        onMouseEnter(resultId, id, link);
    };

    const choiceItemBorderRadiusClass = borderRadiusClass ?? getBorderRadius('choiceItem');

    const responseBgColor = getResponseBgColor('#000000');

    let resultBgWidth = 0;

    $: if (isResultVisible) {
        resultBgWidth = (responsePercentage ?? 0) * 100;
    }
</script>

<div
    role="button"
    class={cn(
        'fun-flex fun-min-h-16 fun-items-center fun-gap-4 fun-border fun-p-4 fun-backdrop-blur-md fun-transition-all active:fun-scale-90',
        !borderColorStyle && 'fun-border-neutral-500/50',
        !bgColor && 'fun-bg-black/50',
        choiceItemBorderRadiusClass,
    )}
    style:background-color={bgColor}
    style:border-color={borderColorStyle}
    on:click={handleClick}
    on:keypress={handleKeyPress}
    on:mouseenter={handleMouseEnter}
    on:touchstart={handleMouseEnter}
    tabindex="0"
>
    <div
        class={cn(
            'fun-absolute fun-inset-0 fun-z-10 fun-size-full fun-transition-all fun-duration-700 [transition-timing-function:cubic-bezier(0.33,1,0.68,1)]',
            choiceItemBorderRadiusClass,
            responseBgColor,
        )}
        style="width: {resultBgWidth}%;"
    />

    {#if showIcon}
        <AnswerIcon
            {emoji}
            {icon}
            {srcType}
            {iconName}
            {platform}
            {iconColor}
            {svg}
            {isAnimated}
            {jsonUrl}
        />
    {/if}
    <span class="fun-line-clamp-2 fun-flex-grow">
        <Text {wysiwygHtml} {color} box={DEFAULT_BOX} transitionEffect="none" />
    </span>

    {#if isResultVisible}
        <div
            class="fun-font-inter fun-relative fun-z-10 fun-flex fun-h-full fun-items-center fun-justify-center fun-text-2xl fun-font-semibold fun-leading-8 fun-tracking-normal"
            style="color: {color}"
            in:fade
        >
            <CountUp
                initial={0}
                value={((responsePercentage || 0) * 100).toFixed(0)}
                duration={700}
                step={1}
                roundto={1}
            />%
        </div>
    {/if}
</div>
